import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-explore-contact-banners',
  templateUrl: './explore-contact-banners.component.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class ExploreContactBannersComponent {
  @Input('userStatus') userStatus: any;
  @Input('user') user: any;
  @Output('optedForSupport') optedForSupport: EventEmitter<string> = new EventEmitter();

  handleSupport(param: string): void {
    this.optedForSupport.emit(param);
  }
}
